import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Package, MapPin, ArrowRightLeft, ShoppingCart } from "lucide-react";
import WarehouseStockTab from "@/components/admin/inventory/WarehouseStockTab";
import EventAllocationsTab from "@/components/admin/inventory/EventAllocationsTab";
import TransfersTab from "@/components/admin/inventory/TransfersTab";
import OrdersTab from "@/components/admin/inventory/OrdersTab";

const EventManagementInventory: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <Package className="h-6 w-6 text-secondary" />
          Inventory & Signage
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage warehouse stock, event allocations, transfers, and purchase orders.
        </p>
      </div>

      <Tabs defaultValue="warehouse-stock">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="warehouse-stock" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Package className="h-4 w-4" />
            <span className="hidden sm:inline">Warehouse Stock</span>
            <span className="sm:hidden">Stock</span>
          </TabsTrigger>
          <TabsTrigger value="event-allocations" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <MapPin className="h-4 w-4" />
            <span className="hidden sm:inline">Event Allocations</span>
            <span className="sm:hidden">Allocations</span>
          </TabsTrigger>
          <TabsTrigger value="transfers" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ArrowRightLeft className="h-4 w-4" />
            <span className="hidden sm:inline">Transfers</span>
            <span className="sm:hidden">Transfers</span>
          </TabsTrigger>
          <TabsTrigger value="orders" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ShoppingCart className="h-4 w-4" />
            <span className="hidden sm:inline">Orders</span>
            <span className="sm:hidden">Orders</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="warehouse-stock" className="mt-6">
          <WarehouseStockTab />
        </TabsContent>
        <TabsContent value="event-allocations" className="mt-6">
          <EventAllocationsTab />
        </TabsContent>
        <TabsContent value="transfers" className="mt-6">
          <TransfersTab />
        </TabsContent>
        <TabsContent value="orders" className="mt-6">
          <OrdersTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementInventory;
